import React from 'react';

const StatusBadge = ({ status, type = 'approval' }) => {
  const approvalConfig = {
    pending: {
      label: 'Pendente',
      className: 'bg-yellow-100 text-yellow-800 border border-yellow-200',
    },
    approved: {
      label: 'Aprovado',
      className: 'bg-green-100 text-green-800 border border-green-200',
    },
    rejected: {
      label: 'Recusado',
      className: 'bg-red-100 text-red-800 border border-red-200',
    },
  };

  const serviceConfig = {
    in_progress: {
      label: 'Em andamento',
      className: 'bg-blue-100 text-blue-800 border border-blue-200',
    },
    finished: {
      label: 'Finalizado',
      className: 'bg-green-100 text-green-800 border border-green-200',
    },
    awaiting_client: {
      label: 'Aguardando cliente',
      className: 'bg-orange-100 text-orange-800 border border-orange-200',
    },
  };

  const legacyConfig = {
    completed: { label: 'Realizado', className: 'bg-green-100 text-green-800 border border-green-200' },
    blocked: { label: 'Bloqueado', className: 'bg-red-100 text-red-800 border border-red-200' },
  };

  const config = type === 'approval'
    ? approvalConfig
    : type === 'service'
    ? serviceConfig
    : legacyConfig;

  const { label, className } = config[status] || {
    label: status,
    className: 'bg-gray-100 text-gray-800 border border-gray-200',
  };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${className}`}>
      {label}
    </span>
  );
};

export default StatusBadge;
